import React, {Suspense} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen} from "./layout";
import modulesRoutes from "./routes/modules";

export default function BasePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /welcome. */
                    <Redirect exact from="/" to="/welcome"/>
                }

                {modulesRoutes.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        children={<route.main/>}
                    />
                ))}

                {
                    /* 404 NOT Found*/
                    <Redirect to="/error"/>
                }
            </Switch>
        </Suspense>
    );
}
